import { render, staticRenderFns } from "./file_dialog.vue?vue&type=template&id=1944518b&scoped=true&"
import script from "./file_dialog.vue?vue&type=script&lang=js&"
export * from "./file_dialog.vue?vue&type=script&lang=js&"
import style0 from "./file_dialog.vue?vue&type=style&index=0&id=1944518b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944518b",
  null
  
)

export default component.exports